const SET_ROLES = 'SET_ROLES';
const SET_ORGANISATIONS = 'SET_ORGANISATIONS';
const SET_SITES = 'SET_SITES';
const SET_FUNCTIONS = 'SET_FUNCTIONS';
const SET_REFERENTIALS = 'SET_REFERENTIALS';
const SET_PAGINATION_LIMIT = 'SET_PAGINATION_LIMIT';
const SET_ROLES_PER_ENDPOINT = 'SET_ROLES_PER_ENDPOINT';

const SET_INITIALIZATION_OK = 'SET_INITIALIZATION_OK';

const SET_DRAWER_SHOW = 'SET_DRAWER_SHOW';
const SET_SIDEBAR_SHOW = 'SET_SIDEBAR_SHOW';
const SET_PANEL_ALIGNMENT = 'SET_PANEL_ALIGNMENT';
const SET_PAGINATION_USER_LIMIT = 'SET_PAGINATION_USER_LIMIT';


const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
const SET_REFRESH_TOKEN = 'SET_REFRESH_TOKEN';
const SET_ROLE = 'SET_ROLE';
const SET_FUNCTION = 'SET_FUNCTION';
const SET_USER_ID = 'SET_USER_ID';
const SET_USER_POSTPONE_ID = 'SET_USER_POSTPONE_ID';
const SET_SAML_CONNECTING = 'SET_SAML_CONNECTING';
const SET_ORGANISATIONS_SETS = 'SET_ORGANISATIONS_SETS';

const REDUCER_ACTIONS = {
  SET_ROLES,
  SET_ORGANISATIONS,
  SET_SITES,
  SET_FUNCTIONS,
  SET_REFERENTIALS,
  SET_PAGINATION_LIMIT,
  SET_ROLES_PER_ENDPOINT,
  SET_INITIALIZATION_OK,

  SET_DRAWER_SHOW,
  SET_SIDEBAR_SHOW,
  SET_PANEL_ALIGNMENT,
  SET_PAGINATION_USER_LIMIT,

  SET_ACCESS_TOKEN,
  SET_REFRESH_TOKEN,
  SET_ROLE,
  SET_FUNCTION,
  SET_USER_ID,
  SET_USER_POSTPONE_ID,
  SET_SAML_CONNECTING,
  SET_ORGANISATIONS_SETS,
}
export default REDUCER_ACTIONS;
